import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 哈萨克
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Барлық құқықтар қорғалған',
    },
    auth: {
        login: 'Кіру',
        username: 'Пайдаланушы аты',
        username_placeholder: 'Пайдаланушы атын енгізіңіз',
        password: 'Құпия сөз',
        password_placeholder: 'Құпия сөзді енгізіңіз',
        code: 'Тексеру коды',
        code_placeholder: 'Тексеру кодын енгізіңіз',
        logout: 'Шығу',
        logout_success: 'Сіз сәтті шықтыңыз',
        day: 'күн',
        password_expiration: 'Құпия сөз мерзімі өткен – өзгерту керек',
        expire: 'Құпия сөз мерзіміне қалған уақыт',
        conseils:
            'Үлкен әріптер, кіші әріптер, сандар және арнайы таңбалар ({msg}) болуы керек. Құпия сөз ұзындығы 8–16 таңба аралығында болуы тиіс.',
        brand_Selection: 'Марканы таңдау',
        unread_notices: 'Оқылмаған хабарландырулар',
        new_cases: 'Жаңа істер',
        unanswered_cases: 'Жауап берілмеген істер',
        overdue_cases: 'Мерзімі өткен істер',
    },
    button: {
        query: 'Сұрау',
        editing_position: 'Лауазымды өңдеу',
        show_theme_editor: 'Тақырып редакторын көрсету/жасыру',
        change_password: 'Құпия сөзді өзгерту',
        old_password: 'Ескі құпия сөз',
        new_password: 'Жаңа құпия сөз',
        confirm_password: 'Құпия сөзді растау',
        button: 'Түйме',
        about: 'Біз туралы',
        back: 'Артқа',
        go: 'ОК',
        home: 'Басты бет',
        confirm: 'Растау',
        modify: 'Өзгерту',
        edit: 'Өңдеу',
        new: 'Жаңа',
        cancel: 'Бас тарту',
        close: 'Жабу',
        search: 'Іздеу',
        reset: 'Қалпына келтіру',
        delete: 'Жою',
        add: 'Қосу',
        collapse: 'Жию',
        expand: 'Жазу',
        download_template: 'Үлгіні жүктеп алу',
        batch_import: 'Топтық импорт',
        import: 'Импорт',
        export: 'Экспорт',
        export_fail: 'Импорт сәтсіз аяқталды',
        detailed: 'Толық ақпарат',
        details: 'Егжей-тегжейі',
        download: 'Жүктеп алу',
        toView: 'Қарау',
        toViews: 'Суреттерді қарау',
        uploadAttachments: 'Қосымшаларды жүктеу',
        selectFile: 'Файлды таңдау',
        fillingInstructions: 'Толтыру нұсқаулығы',
        release: 'Жариялау',
        release_recall: 'Жариялаудан қайту',
        save: 'Сақтау',
        send: 'Жіберу',
        tips: 'Кеңестер',
        send_back: 'Қайтару',
        examine: 'Тексеру',
        void: 'Жоққа шығару',
        more: 'Көбірек',
        refresh: 'Жаңарту',
        selects: 'Таңдаңыз',
        serial_number: 'Реттік нөмір',
        upload_progress: 'Жүктеу прогресі',
        invalid: 'Жарамсыз',
        daily_record: 'Күнделікті журнал',
        operation_type: 'Әрекет түрі',
        field_name: 'Өріс атауы',
        edit_role: 'Рөлді өңдеу',
        user_role: 'Рөлді таңдау',
        assignment_role: 'Рөл',
        post: 'Лауазым',
        sending: 'Жіберілуде...',
        reset_password: 'Құпия сөзді қалпына келтіру',
        display_or_not: 'Көрсету немесе көрсетпеу',
        document: 'Құжат',
        specificTemplates: 'Арнайы үлгілер',
        transferOrder: 'Тапсырысты ауыстыру',
        forwarding: 'Алға жіберу',
        one_click_notification: 'Бір шертумен хабарлау',
        english_export: 'Ағылшын тіліне экспорт',
        oneclick_download: 'Бір шертумен жүктеп алу',
        passwordmsga:
            'Үлкен әріптер, кіші әріптер, сандар және арнайы таңбалар (@\\$!_~\\&*) болуы керек',
        passwordmsgb: 'Құпия сөз ұзындығы 8–16 таңба аралығында болуы тиіс',
        passwordmsgc: 'Алдыңғы алты құпия сөзден ешқайсысымен сәйкес келмеуі керек',
        export_file_list: 'Экспортталатын файлдар тізімі',
        personal_center: 'Жеке кабинет',
        upload_list: 'Жүктелген файлдар тізімі',
        clear_completed: 'Аяқталғандарды тазарту',
    },
    radio: {
        enabled: 'Қосулы',
        disabled: 'Сөндірулі',
        catalogue: 'Каталог',
        individual: 'Жеке',
        all: 'Барлығы',
        yes: 'Иә',
        no: 'Жоқ',
    },
    dropdown: {
        close_others: 'Басқаларын жабу',
        close_right: 'Оң жағын жабу',
        close_left: 'Сол жағын жабу',
    },
    table: {
        action: 'Әрекет',
        explain: 'Түсіндіру',
        fileName: 'Файл атауы',
        size: 'Өлшемі (МБ)',
        uploader: 'Жүктеген адам',
        uploadTime: 'Жүктелген уақыт',
        system: 'Жүйе',
        caption: 'Тақырыбы',
        categorization: 'Санаттау',
        link: 'Сілтеме',
        forwarding_time: 'Алға жіберілген уақыт',
        forwarder: 'Алға жіберген адам',
        send_to: 'Кімге жіберу',
        mode: 'Режим',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `${named('number')} бет`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `Барлығы ${named('number')} жазба`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) => `Барлығы ${named('number')} көлік`,
    },
    confirm: {
        confirm_deletion: 'Жоюды растау керек пе?',
        confirm_void: 'Жоққа шығаруды растау керек пе?',
        confirm_release: 'Жариялауды растау керек пе?',
        ack: 'Растау',
        cancel: 'Бас тарту',
        non_records: 'Кем дегенде бір жазбаны таңдаңыз',
    },
    request: {
        failed_placeholder: 'Сұраныс сәтсіз аяқталды – сервер қатесі',
        success_placeholder: 'Сұраныс сәтті орындалды',
        auth: {
            login_success: 'Сіз сәтті кірдіңіз',
        },
        error: {
            '404': 'Сұраныс жолы табылмады',
            '403': 'Рұқсаттар жеткіліксіз',
        },
    },
    page: {
        global: {
            page_search: 'Беттен іздеу',
        },
        error: {
            not_found: 'Бет табылмады',
            not_found_des: 'Мұнда ештеңе жоқ',
            auth_failed: 'Рұқсаттар жеткіліксіз',
            auth_failed_des: 'Бұл бетке кіруге тыйым салынған',
            file_format_error: 'Файл форматы қате!',
            preview_failed: 'Алдын ала қарау сәтсіз аяқталды! Файл зақымдалған!',
        },
        homepage: {
            homepage: homepage.homepage.kkKZ,
        },
        system: {
            menu: system.menu.kkKZ,
            dict: system.dict.kkKZ,
            dept: system.dept.kkKZ,
            role: system.role.kkKZ,
            user: system.user.kkKZ,
        },
        info: {
            announcement: Info.announcement.announcement.kkKZ,
            document: Info.document.document.kkKZ,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.kkKZ,
                recallActivity: tech.quality.recallActivity.kkKZ,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.kkKZ,
            },
            management: {
                inquiryOd: tech.management.inquiry.kkKZ,
                permission: tech.management.permission.kkKZ,
                onSiteSupportHq: tech.management.onSiteSupport.kkKZ,
                progHistoryHq: tech.management.progHistory.kkKZ,
                salesRecordHq: tech.management.salesRecord.kkKZ,
                vehicleInfoHq: tech.management.vehicleInfo.kkKZ,
                claimHq: tech.management.claim.kkKZ,
                filterHq: tech.management.filter.kkKZ,
                newCarlssue: tech.management.newCarIssue.kkKZ,
                newCarDefinition: tech.management.newCarDefinition.kkKZ,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.kkKZ,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.kkKZ,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.kkKZ,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.kkKZ,
        },
        statistics: statistics.inquiryStatistics.kkKZ,
        systemClassifyA: statistics.systemClassifyA.kkKZ,
        systemClassifyB: statistics.systemClassifyB.kkKZ,
        engineerStatistics: statistics.engineerStatistics.kkKZ,
        defectivePart: statistics.defectivePart.kkKZ,
        replyInquiryStatistics: statistics.replyInquiryStatistics.kkKZ,
        passRateStatistics: statistics.passRateStatistics.kkKZ,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.kkKZ,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.kkKZ,
        customsClearance135Rate: statistics.customsClearance135Rate.kkKZ,
        accumulatedClosureRate: statistics.accumulatedClosureRate.kkKZ,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.kkKZ,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.kkKZ,
    },
    validation: {
        common: {
            required: 'Бұл өрісті толтыру міндетті',
            numeric: 'Бүтін сан болуы керек',
            decimal: 'Сан болуы керек',
            positive_interger: 'Оң бүтін сан болуы керек',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Ең көбі ${named('number')} цифр`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `${named('number')} таңбадан аспауы керек`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Максималды таңба санын (${named('number')}) асып кетті`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Кем дегенде ${named('number')} таңба`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Дәл ${named('number')} таңба болуы керек`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `${named('number')} санынан аспауы керек`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `${named('number')} санынан кем болмауы керек`,
            up_to_2_decimal_places: 'Нүктеден кейін ең көбі 2 цифра',
            retain_up: 'Нүктеден кейін ең көбі 10 цифра, нүктеден кейін ең көбі 2 цифра',
            retain_ups: 'Нүктеден кейін ең көбі 11 цифра, нүктеден кейін ең көбі 4 цифра',
            input_number: 'Араб цифрларын ғана енгізіңіз',
            only_number_a: 'Тек әріптер немесе цифрлар ғана болуы мүмкін',
            translate: 'Тек әріптер болуы мүмкін',
            positive_integer: 'Кем дегенде бір өрісті толтырыңыз',
            at_least_one: 'Кем дегенде біреуін толтырыңыз',
        },
        tip: {
            incomplete_information: 'Ақпарат толық емес',
        },
    },
    import: {
        template_file: 'Үлгі файл',
        browse: 'Шолу',
        download_template: 'Үлгіні жүктеп алу',
        no_file_selected: 'Файл таңдалмады',
        incorrect_file_type: 'Файл түрі дұрыс емес',
        exceed: 'Асып кету',
        upload_success: 'Жүктеу сәтті аяқталды',
        upload_fail: 'Жүктеу сәтсіз аяқталды',
        again_upload:
            'Тек jpg, png, bmp немесе gif форматындағы суреттерді жүктеуге болады. Қайталап көріңіз.',
        attachmentUpload: 'Қосымшаларды жүктеу',
        otherAttachmentUpload: 'Басқа қосымшаларды жүктеу',
        supportedFormats: 'Қолдау көрсетілетін форматтар',
        preview: 'Алдын ала қарау',
    },
    export: {
        noDataToExport: 'Экспорттау үшін деректер жоқ',
    },
    select: {
        all: 'Барлығы',
    },
    checkbox: {
        select_all: 'Барлығын таңдау',
    },
    dialog: {
        error_message: 'Қате туралы хабарлама',
        one_year: 'Бір ретте максимум бір жылдық деректерді экспорттауға болады',
    },
    ymd: {
        year: 'жыл',
        month: 'ай',
        day: 'күн',
        week: 'апта',
        january: 'Қаңтар',
        february: 'Ақпан',
        march: 'Наурыз',
        april: 'Сәуір',
        may: 'Мамыр',
        june: 'Маусым',
        july: 'Шілде',
        august: 'Тамыз',
        september: 'Қыркүйек',
        october: 'Қазан',
        november: 'Қараша',
        december: 'Желтоқсан',
    },
};
